import { inject, Injectable } from '@angular/core';
import { DialogTableDataRow } from '../../content/interfaces/dialog-table-data-row';
import { OrganisationData } from '../../content/interfaces/organisation/organisation-data';
import { UserData } from '../../content/interfaces/user-data';
import { SettingsProviderService } from '../../content/services/settings-provider.service';
import { I18nService } from '../../core/services/i18n.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileCustomerToTableDataMapperService {

  i18n = inject(I18nService);
  settingsProviderService = inject(SettingsProviderService);

  public map(userData: UserData, organisationData: OrganisationData): DialogTableDataRow[] {
    return [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'MERCHANTID',
        value: organisationData.displayCustomerNumber,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'CUSTOMERNAME',
        value: organisationData.name
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'LEGALFORMLABEL',
        value: this.settingsProviderService.legalForm.find(item => item.value === organisationData.legalForm) ? this.settingsProviderService.legalForm.find(item => item.value === organisationData.legalForm).label : '',
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'ADDRESSLABEL',
        valueType: 'MULTILINE',
        value: this.addressBuilder(organisationData)
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PHONE',
        value: organisationData.phone
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'EMAILADDRESS',
        value: organisationData.email
      },
      {
        titleStyleClass: 'font-bold',
        title: 'URL',
        value: organisationData.url
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'CUSTOMERPAYMENTMETHOD',
        value: this.i18n.i18nLng()[organisationData.paymentMethod]
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'MANDATEREFERENCE',
        value: organisationData.mandateReference
      },
    ];
  }

  private addressBuilder(organisationData: OrganisationData): string {
    let address: string = '';
    address += organisationData.name;
    if (organisationData?.streetNr && organisationData?.streetNr.trim().length > 0) {
      if (address.trim().length > 0) {
        address += '\n';
        address += organisationData.streetNr;
      }
    }
    if (organisationData?.addressLine2 && organisationData?.addressLine2.trim().length > 0) {
      if (address.trim().length > 0) {
        address += '\n';
        address += organisationData.addressLine2;
      }
    }
    if ((organisationData?.postalCode && organisationData?.postalCode.trim().length > 0) || (organisationData?.city && organisationData?.city.trim().length > 0)) {
      if (address.trim().length > 0) {
        address += '\n';
        if (organisationData?.postalCode && organisationData?.postalCode.trim().length > 0) {
          address += (organisationData.postalCode + ' ');
        }
        address += organisationData?.city;
      }
    }
    if (address.trim().length > 0) {
      address += '\n';
      address += this.i18n.getCountryById(organisationData?.country);
    }
    return address;
  }
}
